module.exports = __webpack_public_path__ + "img/step3.144b048c.svg";